import React from "react";
import { Link } from "react-router-dom";
import Wordmark from "./Wordmark";

export function LegalSection({ title, children }) {
  return (
    <section className="mb-12 pb-12 border-b border-[#0E1A1A] last:border-0 last:mb-0 last:pb-0">
      <h2 className="font-display text-lg font-semibold text-white mb-5">{title}</h2>
      <div className="space-y-4 text-[#9BB8B8] text-sm leading-[1.8]">
        {children}
      </div>
    </section>
  );
}

export function LegalList({ items }) {
  return (
    <ul className="space-y-2.5 pl-1">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-3">
          <span className="w-1 h-1 rounded-full bg-[#FF4F00] mt-2.5 shrink-0" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export default function LegalLayout({ title, subtitle, lastUpdated, badge, children }) {
  return (
    <div className="min-h-screen bg-[#060C0C] text-white relative overflow-x-hidden">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" aria-hidden />

      <header className="relative z-10 pt-8 pb-4 px-6 lg:px-12 max-w-[1200px] mx-auto flex items-center justify-between">
        <Link to="/" className="hover:opacity-80 transition-opacity">
          <Wordmark size="lg" />
        </Link>
        <Link to="/" className="text-sm text-[#9BB8B8] hover:text-white transition-colors">
          ← Back
        </Link>
      </header>

      <div className="relative z-10 max-w-[760px] mx-auto px-6 lg:px-12 pt-14 pb-12 border-b border-[#0E1A1A]">
        <div className="text-[11px] uppercase tracking-[0.22em] text-[#FF4F00] font-bold mb-3">
          {badge || "Legal"}
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-medium tracking-[-0.035em] leading-[1.05] mb-4">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[#9BB8B8] text-lg leading-relaxed max-w-xl">{subtitle}</p>
        )}
        {lastUpdated && (
          <p className="text-xs text-[#7A9B9B] font-mono mt-5">Last updated: {lastUpdated}</p>
        )}
      </div>

      <main className="relative z-10 max-w-[760px] mx-auto px-6 lg:px-12 py-16 pb-32">
        {children}
      </main>
    </div>
  );
}
